<template>
  <div>
    <div class="box" style="min-width: 980px;">
      <div class="columns">
        <div class="column">
          <div style="padding: 0px 0px 20px 555px; width: 894px; border-bottom: 1px solid lightgrey;" class="container content">
            <i v-if="loading" style="margin-left: 290px;" class="fa fa-refresh fa-spin fa-lg opaque"></i>
            <div v-if="!loading">
              <a ref="pdfIE" v-if="isIE">
                <button class="button is-link">
                  Download Insurance Certificate (PDF)
                  <i v-if="!loading" style="padding-left: 10px;" class="fa fa-lg fa-download"></i>
                </button>
              </a>
              <a ref="pdf" v-if="!isIE" :download="fileName" :href="pdflink">
                <button class="button is-link">
                  Download Insurance Certificate (PDF)
                  <i v-if="!loading" style="padding-left: 10px;" class="fa fa-lg fa-download"></i>
                </button>
              </a>
              <div v-if="association.Attachments && association.Attachments.length > 0" class="content is-small" style="margin-top: 20px; max-width: 330px; word-break: break-all;">
                <h4>Additional Declarations</h4>
                <ul class="table" style="margin-top: 10px; font-size: 13px; margin-bottom: 0px;">
                  <li v-for="attachment in association.Attachments">
                    <a :href="attachment.downloadURL" target="_blank">{{attachment.fileName}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <Accord24 ref="accord" :readonly="true" :accord24="accord24"></Accord24>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Accord24 from '@/components/associations/Accord24'
  import accordUtil from '@/utilities/accord-util'
  import axios from 'axios'
  export default {
    name: 'RequestComplete',
    props: ['accord24', 'association'],
    data: function () {
      return {
        loading: true,
        isIE: false,
        submitted: false,
        found: false,
        pdflink: '',
        fileName: ''
      }
    },
    mounted() {
      this.$nextTick(() => {
        let accordForm = this.$refs['accord'].$el.outerHTML
        let rawHTML = this.getAccordDOM(accordForm)
        axios.post(process.env.API_BASE_URL + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then((response) => {
          this.loading = false
          let blob = new Blob([response.data], { type: 'application/pdf' })
          if (navigator.appVersion.toString().indexOf('.NET') > 0) {
            this.isIE = true
            this.$nextTick(() => {
              this.$refs['pdfIE'].addEventListener('click', () => {
                window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf')
              })
            })
          } else {
            this.pdflink = window.URL.createObjectURL(blob)
            this.fileName = 'InsuranceCertificate.pdf'
          }
        }).catch((error) => {
          console.log(error)
          this.loading = false
        })
      })
    },
    methods: {
      next() {
        this.submitted = true
        this.found = false
        setTimeout(() => {
          this.$emit('next', 2)
          this.submitted = false
          this.found = true
        }, 2500)
      },
      previous() {
        this.$emit('previous')
      },
      getAccordDOM(accordForm) {
        return accordUtil.getAccordDOM(accordForm)
      }
    },
    components: {
      Accord24
    }
  }

</script>

<style scoped>
  .hov:hover {
    color: blue;
  }
</style>


// WEBPACK FOOTER //
// src/components/request/RequestComplete.vue?2ad1ef14